import styled from '../styled-components';
import { PrismDiv } from './PrismDiv';
export const SampleControls = styled.div.withConfig({
  displayName: "samples__SampleControls",
  componentId: "sc-46belp-0"
})(["opacity:1;transition:opacity 0.3s ease;text-align:right;> span{display:inline-block;padding:2px 10px;cursor:pointer;color:#908e8f;font-size:0.875em;border-radius:16px;:hover{background:#e8e8e8;}}"]);
export const SampleControlsWrap = styled.div.withConfig({
  displayName: "samples__SampleControlsWrap",
  componentId: "sc-46belp-1"
})(["&:hover ", "{opacity:1;}"], SampleControls);
export const StyledPre = styled(PrismDiv.withComponent('pre')).withConfig({
  displayName: "samples__StyledPre",
  componentId: "sc-46belp-2"
})(["font-family:", ";font-size:", ";overflow-x:auto;margin:0;white-space:", ";"], props => props.theme.typography.code.fontFamily, props => props.theme.typography.code.fontSize, ({
  theme
}) => theme.typography.code.wrap ? 'pre-wrap' : 'pre');